<!-- 标题组件（标题左侧含紫色矩形竖条） -->
<template>
  <div class="header">
    <div class="header__left">
      <div class="flex-align-center">
        <div class="header-icon"></div>
        <h4 class="header-title">{{ title }}</h4>
      </div>
      <p v-if="desc" class="header__left-desc text-color-auxiliary text-normal-4">{{ desc }}</p>
    </div>
    <div class="flex-align-center">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  // 标题文字
  title: {
    type: String,
    default: '示例标题'
  },
  // 描述文字
  desc: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.flex-align-center {
  display: flex;
  align-items: center;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &__left {
    display: flex;
    flex-direction: column;

    &-desc {
      margin-top: 4px;
    }
  }

  &-icon {
    width: 4px;
    height: 16px;
    border-radius: 4px;
    background: #7a52f4;
    margin-right: 8px;
  }

  &-title {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    color: #323233;
  }
}
</style>
